import actions from 'actions/assets'
import { createFormViewContainer } from 'factories/FormView'
import {
  createChildItemsDispatchToProps,
  createLinkedItemsDispatchToProps,
  createDocumentsDispatchToProps,
} from 'helpers/formViews'
import locationActions from 'actions/locations'
import assetCategoryActions from 'actions/assetCategories'
import userActions from 'actions/users'
import userGroupActions from 'actions/userGroups'
import inventoryActions from 'actions/inventory'
import documentActions from 'actions/documents'
import assetWarrantyActions from 'actions/assets/assetWarranties'
import assetToleranceActions from 'actions/assets/assetTolerances'
import assetHistoryActions from 'actions/assets/assetHistory'
import taskActions from 'actions/tasks'
import formInstanceActions from 'actions/formInstances'
import Component from 'components/Assets/FormView'

export default createFormViewContainer({
  actions,
  extraDispatchToProps: (dispatch, props) => ({
    generateId: (params) => dispatch(actions.generateId(params)),
    getLocations: (params) =>
      dispatch(locationActions.getItems({ ...params, locationVendingTypes: ['NonVending'] })),
    getAssetCategories: (params) => dispatch(assetCategoryActions.getOptions(params)),
    getUsers: (params) => dispatch(userActions.getItems(params)),
    getUserGroups: (params) => dispatch(userGroupActions.getOptions(params)),
    getInventoryAvailability: (params) => dispatch(inventoryActions.getAvailability(params)),
    updateMileage: (params) => dispatch(actions.updateMileage(params)),
    updateServiceHours: (params) => dispatch(actions.updateServiceHours(params)),
    ...createDocumentsDispatchToProps(dispatch, documentActions),
    ...createLinkedItemsDispatchToProps(dispatch, 'Task', taskActions),
    ...createChildItemsDispatchToProps(dispatch, 'Warranty', assetWarrantyActions),
    ...createChildItemsDispatchToProps(dispatch, 'Tolerance', assetToleranceActions),
    ...createChildItemsDispatchToProps(dispatch, 'History', assetHistoryActions),
    ...createLinkedItemsDispatchToProps(dispatch, 'FormInstance', formInstanceActions),
  }),
})(Component)
